import React, { useEffect, useState } from 'react'
import cn from 'classnames'

import { ReactComponent as IconInfo } from '../../assets/icons/IconInfo.svg'
import { useCustomTooltipStyles } from '../../stylesheets/customMaterialUIstyles'
import Tooltip from '@material-ui/core/Tooltip'

const CheckboxGroupItem = ({
  checked,
  className,
  defaultChecked,
  disabled,
  handleOpenModal,
  id,
  isEditModalOpen,
  isIcon = true,
  label,
  onChange,
  subtext,
  textAlignLeft,
  tooltipText,
}) => {
  const customTooltipClasses = useCustomTooltipStyles()
  const [isSignatoryIconClicked, setIsSignatoryIconClicked] = useState(false)
  const [isModalMode, setIsModalMode] = useState(false)

  useEffect(() => {
    if (!isEditModalOpen) {
      setIsSignatoryIconClicked(false)
      setIsModalMode(false)
    }
  }, [isEditModalOpen, isModalMode])

  useEffect(() => {
    if (isSignatoryIconClicked) {
      setIsModalMode(true)
    }
  }, [isSignatoryIconClicked])

  return (
    <div className="checkbox-group-item-wrapper">
      <label className={cn('checkbox-with-label checkbox-group-item', '-checkbox', className)}>
        <input
          className='checkbox-with-label__input checkbox-group-item__input'
          id={id}
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          type='checkbox'
        />
        <div className="checkbox-with-label__checkbox" />
        {renderLabelAndSubtext(label, subtext, textAlignLeft)}
        <div className="checkbox-group-item__border"></div>
      </label>
      {isIcon && (
        <div className="checkbox-group-item__info" onClick={handleOpenModal}>
          <Tooltip classes={customTooltipClasses} title={tooltipText} arrow placement="top">
            <IconInfo />
          </Tooltip>
        </div>
      )}
    </div>
  )
}

const renderLabelAndSubtext = (
  label,
  subtext,
  textAlignLeft,
  ) => {
  const topLabelClasses = cn('top-label', {
    '-text-align-left': textAlignLeft
  })

  if (subtext) {
    return (<div>
      <div className={topLabelClasses}>{label}</div>
      <div className="bottom-label">{subtext}</div>
    </div>)
  }

  return (<div>
    <div className={topLabelClasses}>{label}</div>
  </div>)
}

export default CheckboxGroupItem
